import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import withCardBorderWidth from '../../hoc/with-card-border-width';
import withFontClassName from '../../hoc/with-font-class-name';
import { handleEnterKeyUp } from '../../services/accessibility';
import styles from './menu-tab.scss';

const MenuTab = ({ className, title, count, isActive, borderWidth, contentFontClassName, onClick, ...props }) => {
  const containerClassName = classNames(
    styles.link,
    className,
    contentFontClassName,
    { [styles.linkActive]: isActive },
    'menu-tab',
    isActive ? classNames('button-color', 'button-border-color') : 'forum-text-color'
  );
  return (
    <a
      className={containerClassName}
      style={{ borderWidth: Math.max(borderWidth, 1) }}
      tabIndex={!isActive && '0'}
      onClick={onClick}
      onKeyUp={handleEnterKeyUp(onClick)}
      {...props}
    >
      <span className={styles.wrapper}>
        <span className={classNames(styles.title, 'menu-tab__title')}>
          {title}
        </span>
        <span className={classNames(styles.count, { [styles.zeroCount]: count === 0 }, 'menu-tab__count')}>
          {count}
        </span>
      </span>
    </a>
  );
};

MenuTab.propTypes = {
  borderWidth: PropTypes.number.isRequired,
  contentClassName: PropTypes.string.isRequired,
  contentFontClassName: PropTypes.string.isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
  count: PropTypes.number,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
};

export default withCardBorderWidth(withFontClassName(MenuTab));



// WEBPACK FOOTER //
// ./app/components/menu-tab/menu-tab.js